import { Box, useTheme } from '@mui/material';
import React, { FC } from 'react';
import "./BesmartBotAnim.css";

interface Props {
	size: number;
	delay: number;
}

const PulsingCircle: FC<Props> = ({size, delay,}) => {
	const theme = useTheme();

	return (
		<Box sx={{
			position: "absolute",
			width: size,
			opacity: 0,
			height: size,
			border: `2px solid ${theme.myTheme.colors.primary100}`,
			borderRadius: "50%",
			animation: `pulse 2.4s infinite ease-in-out`,
			animationDelay: `${delay}s`
		}}>
		</Box>
	);
};

export default PulsingCircle;